import table from '@/store/table';

// state
export const state = table.state();

// mutations
export const mutations = table.mutations();

// actions
export const actions = table.actions('measures');

// getters
export const getters = {};
